import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "previews", "error", "progress", "progressLabel", "removal"]
  static values = { acceptedTypes: Array, acceptedTypesLabel: String, maxSize: Number, maxSizeLabel: String, maxCount: Number, existingCount: Number }

  connect() {
    this.previewUrls = []
  }

  disconnect() {
    this.releasePreviews()
  }

  select(event) {
    this.clearError()
    const files = Array.from(event.target.files)
    const invalidType = files.find(file => !this.acceptedTypesValue.includes(file.type))
    const oversized = files.find(file => file.size > this.maxSizeValue)

    if (invalidType) return this.reject(`Please upload ${this.acceptedTypesLabelValue} images only`)
    if (oversized) return this.reject(`Each image must be no more than ${this.maxSizeLabelValue}`)
    const retainedCount = this.existingCountValue - this.removalTargets.filter(input => input.checked).length
    if (this.maxCountValue > 0 && retainedCount + files.length > this.maxCountValue) {
      return this.reject(`A catch can have up to ${this.maxCountValue} photos`)
    }

    this.renderPreviews(files)
  }

  uploadStart() {
    this.updateProgress(0)
  }

  uploadProgress(event) {
    this.updateProgress(Math.round(event.detail.progress))
  }

  uploadError(event) {
    event.preventDefault()
    this.showError(event.detail.error || "Image upload failed. Please try again.")
  }

  uploadEnd() {
    this.updateProgress(100, "Upload complete")
  }

  reject(message) {
    this.inputTarget.value = ""
    this.releasePreviews()
    this.previewsTarget.replaceChildren()
    this.showError(message)
  }

  renderPreviews(files) {
    this.releasePreviews()
    this.previewsTarget.replaceChildren(...files.map(file => {
      const image = document.createElement("img")
      const url = URL.createObjectURL(file)
      this.previewUrls.push(url)
      image.src = url
      image.alt = `Preview of ${file.name}`
      image.className = "aspect-video w-full rounded-lg object-cover"
      return image
    }))
  }

  releasePreviews() {
    this.previewUrls.forEach(url => URL.revokeObjectURL(url))
    this.previewUrls = []
  }

  updateProgress(value, label = `${value}% uploaded`) {
    this.progressTarget.value = value
    this.progressTarget.classList.remove("hidden")
    this.progressLabelTarget.textContent = label
    this.progressLabelTarget.classList.remove("hidden")
  }

  showError(message) {
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("hidden")
  }

  clearError() {
    this.errorTarget.textContent = ""
    this.errorTarget.classList.add("hidden")
  }
}
